export const apiKey = "AIzaSyAq3ypn4xpDpaquusYVJ3e00OHhLnH7__k";

export const firstBox = {
    border: "1px dashed black", 
    width: "90%", 
    display: "flex", flexDirection: "column", alignItems: "center",
    paddingTop: "2rem", paddingBottom: "2rem"
};

export const headerTypo = {
    fontWeight: "bold", color: "green", fontSize: "26px"
}

export const containerBox = {
    display: "flex", flexDirection: "column", alignItems: "center"
}

export const excelDataStyle = {
    fontFamily: "Arial, sans-serif", fontSize: "16px", fontWeight: "bold", width: "320px"
}

export const centerBText = {
    textAlign: "center", fontWeight: "bold",
}
